module.exports = __webpack_public_path__ + "img/bubles.1c90ad7e.gif";